import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { Dayjs } from 'dayjs';
import { FormHelperText } from '@mui/material';

import TimeickerContainer from './CustomTimePicker.style';

type PropsType = {
  value?: Dayjs;
  errorText?: string;
  isTouched?: boolean;
  onChange?: (value: Dayjs | null) => void;
  onClose?: () => void;
  hideHelperText?: boolean;
};

const CustomDatePicker = ({
  value,
  errorText,
  isTouched,
  hideHelperText,
  onChange = () => null,
  onClose = () => null,
}: PropsType) => {
  const isErrorDisplay = isTouched && Boolean(errorText);
  return (
    <TimeickerContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          value={value}
          onChange={onChange}
          onClose={onClose}
          slotProps={{
            textField: {
              error: isErrorDisplay,
            },
          }}
        />
      </LocalizationProvider>
      {isErrorDisplay && !hideHelperText && (
        <FormHelperText error={isErrorDisplay}>{errorText}</FormHelperText>
      )}
    </TimeickerContainer>
  );
};

export default CustomDatePicker;
